import './Index.css'
import './Inro/index.scss'
import { useEffect } from 'react'

import logoNacer from '../../assets/images/logo-nacer.webp'

// const slides = [
//   {
//     title: 'Tayara Marketplace',
//     category: 'UX/UI',
//     description:
//       'Tayara.tn is an online marketplace in Tunisia serving more than 1.5M users, connecting buyers and sellers for a range of products and services. Users can browse categories like real estate, vehicles, electronics, and more.',
//     image: Tayara,
//     mobileFrameImage: tayaraMobileFrame,
//     link: '/tayara',
//     Role: 'UX/UI Designer, Frontend developer',
//     Technologies: 'Next.js, Jotai, Typescript, Tailwind CSS, Figma',
//   },
// ]

export default function IntroPages() {
  useEffect(() => {
    window.location.href = 'https://nacermediouni.vercel.app/'
  }, [])

  return (
    <div class="spinner-wrap-on-loading">
      <div className="loading-container">
        <img className="logo-on-loading" src={logoNacer} alt="" />
        <div class="spinner-item"></div>
        <div class="spinner-item spinner-item--2"></div>
      </div>
    </div>
  )
}
